// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"231":"blueprint-icons-split-paths-by-size-loader","824":"blueprint-icons-all-paths-loader"}[chunkId] + "." + {"231":"c10f4c75","824":"caa94596"}[chunkId] + ".chunk.js";
};